import { l10n } from '@ott/l10n';

export const DEFAULT_WEEK_PARAMS = {
  calendarBaseWeekStart: 1,
  weekdays: [
    { label: l10n('calendar.weekdaysShort.Monday') },
    { label: l10n('calendar.weekdaysShort.Tuesday') },
    { label: l10n('calendar.weekdaysShort.Wednesday') },
    { label: l10n('calendar.weekdaysShort.Thursday') },
    { label: l10n('calendar.weekdaysShort.Friday') },
    { label: l10n('calendar.weekdaysShort.Saturday'), isWeekend: true },
    { label: l10n('calendar.weekdaysShort.Sunday'), isWeekend: true },
  ],
};
